import { watchAddDealerPowerAssessment } from './addPowerAssessment';
import { watchFetchDealer } from './fetchDealer';
import { watchFetchDealerList } from './fetchDealerList';
import { watchFetchDealerOpenOrders } from './fetchDealerOpenOrders';
import { watchFetchDealerFinancials } from './fetchFinancials';
import { watchFetchDealerOrders } from './fetchOrders';
import { watchFetchDealerPowerAssessments } from './fetchPowerAssessments';
import { watchFetchDealerPreseason } from './fetchPreseason';
import { watchFetchDealerShipments } from './fetchShipments';
import { watchUpdatePreseasonGoal } from './updatePreseasonGoal';
import { watchUpdateProgram } from './updateProgram';

export const dealerSagas = [
  watchAddDealerPowerAssessment(),
  watchFetchDealer(),
  watchFetchDealerFinancials(),
  watchFetchDealerList(),
  watchFetchDealerOrders(),
  watchFetchDealerPowerAssessments(),
  watchFetchDealerPreseason(),
  watchFetchDealerShipments(),
  watchUpdatePreseasonGoal(),
  watchUpdateProgram(),
  watchFetchDealerOpenOrders()
];
